import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function InviteIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_invite)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.28075 6.25911L12.2082 10.8836L18.5436 6.25911H5.28075ZM11.3273 13.3194L3.05892 7.79977V17.2344C3.05892 17.2906 3.10445 17.3362 3.16063 17.3362H20.8392C20.8954 17.3362 20.9409 17.2906 20.9409 17.2344V7.62295L12.9604 13.4482C12.4518 13.8195 11.7576 13.7531 11.3273 13.3194ZM0.543945 6.36083C0.543945 4.91567 1.71548 3.74414 3.16063 3.74414H20.8392C22.2844 3.74414 23.4559 4.91567 23.4559 6.36083V17.2344C23.4559 18.6796 22.2844 19.8511 20.8392 19.8511H3.16063C1.71548 19.8511 0.543945 18.6796 0.543945 17.2344V6.36083Z"
            fill="url(#paint0_linear_invite)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_invite"
            x1="0.543945"
            y1="7.23722"
            x2="6.58505"
            y2="24.7961"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_invite">
            <Rect
              width="22.4"
              height="15.604"
              fill="white"
              transform="translate(0.799805 4)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
